import moduleDescriptions from 'root/src/shared/descriptions/modules'
import {
	generalApiModuleDescriptionLenses,
} from 'root/src/client/logic/api/lenses'

const { viewListPayloadMap } = generalApiModuleDescriptionLenses

export const moduleEndpointIdSelectorHof = moduleDescriptionsObj => (
	state, { moduleId },
) => viewListPayloadMap(moduleId, moduleDescriptionsObj)

export default moduleEndpointIdSelectorHof(moduleDescriptions)
